var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zyncro-loader",style:(_vm.loaderStyle),attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"zyncro-loader__halo"}),_c('span',{staticClass:"zyncro-loader__mark"},[_c('img',{staticClass:"zyncro-loader__icon",attrs:{"src":_vm.iconSource,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }